import { mountSearchspringBadges } from "../../snippets/ss-badges/mountSearchspringBadges";

const PRODUCT_SLIDER_TABS_SELECTOR = ".js-tabs";
const PRODUCT_SLIDE_SELECTOR = "swiper-slide[data-product-handle]";

function getSiteIdFromContainer(tabsContainer: HTMLElement): string {
  return tabsContainer.dataset.siteId?.trim() ?? "";
}

async function runForContainer(tabsContainer: HTMLElement): Promise<void> {
  const siteId = getSiteIdFromContainer(tabsContainer);
  if (!siteId) return;

  const productSlideElements = tabsContainer.querySelectorAll<HTMLElement>(
    PRODUCT_SLIDE_SELECTOR
  );
  if (!productSlideElements.length) return;

  await mountSearchspringBadges({
    siteId,
    cards: productSlideElements,
    getHandleFromCard: (card) => card.dataset.productHandle?.trim() ?? "",
  });
}

function mountIn(root: ParentNode): void {
  root.querySelectorAll(PRODUCT_SLIDER_TABS_SELECTOR).forEach((container) => {
    if (!(container instanceof HTMLElement)) return;
    void runForContainer(container);
  });
}

mountIn(document);
